import SimpleHeader from '../../components/SimpleHeader/SimpleHeader.jsx';
import Footer from '../../components/Footer/Footer.jsx';
import InquiryForm from './InquiryForm.jsx';
import styles from './ProcessPage.module.css';

/**
 * 가맹 프로세스 페이지.
 * 구성: 가맹 안내(브랜드 인트로) → 8단계 프로세스 → 가맹문의 신청서(구글폼 연결).
 */
export default function ProcessPage() {
  return (
    <>
      <SimpleHeader />

      <main className={styles.main}>
        {/* ═══ 가맹 안내 브랜드 인트로
             구성: 로고+캐릭터 → 헤드카피+영문로고 → 체크 2개 → BRIDGE 밴드 → 3열 가치 → 알약 CTA ═══ */}
        <section className={styles.frIntro}>
          {/* 히어로 밴드: 회색 풀블리드, 텍스트(좌)+캐릭터(우) */}
          <div className={styles.frHeroBand}>
            <div className={`wrap ${styles.frHero}`}>
              <div className={styles.frCopy}>
                <p className={styles.headline}>
                  즐겁게 시작하고 습관으로 성장하는 영어
                  <br />
                  6~9세 영어 프랜차이즈{' '}
                  <img src="/assets/logo_ko_cut.png" alt="잉글리시팝" className={styles.logoInline} />
                </p>
                <p className={styles.frSub}>
                  비상교육의 교육 노하우로 준비된 잉글리시팝과 함께
                  <br />
                  첫 영어 시장의 성공 스토리를 만들어가실 <b className={styles.hl}>원장님을 모십니다!</b>
                </p>
                <div className={styles.frChecks}>
                  <div className={styles.frCheck}>
                    <span className={styles.chk}>✔</span>
                    <span>우리 아이의 가장 완벽한, 10년의 첫 페이지 잉글리시팝이 책임집니다.</span>
                  </div>
                  <div className={styles.frCheck}>
                    <span className={styles.chk}>✔</span>
                    <span>
                      잉글리시팝과 함께 <span className={styles.hl}>'전환기 영어'</span>라는 새로운 시장이 열립니다.
                    </span>
                  </div>
                </div>
              </div>
              <div className={styles.frChar} aria-hidden="true">
                <img src="/characters_3d/alligator.webp?v=2" alt="" />
              </div>
            </div>
          </div>

          <div className="wrap">
            {/* BRIDGE 밴드 */}
            <div className={styles.frBridge}>
              <div className={styles.frBridgeArt} aria-hidden="true">
                <svg viewBox="0 0 280 118" fill="none">
                  {/* 타이드아치교: 데크 + 안쪽에서 솟는 아치 + 행어 5개 + 교각 2개 */}
                  <path d="M34 88 Q 140 -6 246 88" stroke="#0a44a0" strokeWidth="8" strokeLinecap="round" />
                  <line x1="8" y1="88" x2="272" y2="88" stroke="#0a44a0" strokeWidth="8" strokeLinecap="round" />
                  <line x1="76" y1="58" x2="76" y2="84" stroke="#0a44a0" strokeWidth="4.5" strokeLinecap="round" />
                  <line x1="108" y1="45" x2="108" y2="84" stroke="#0a44a0" strokeWidth="4.5" strokeLinecap="round" />
                  <line x1="140" y1="41" x2="140" y2="84" stroke="#0a44a0" strokeWidth="4.5" strokeLinecap="round" />
                  <line x1="172" y1="45" x2="172" y2="84" stroke="#0a44a0" strokeWidth="4.5" strokeLinecap="round" />
                  <line x1="204" y1="58" x2="204" y2="84" stroke="#0a44a0" strokeWidth="4.5" strokeLinecap="round" />
                  <line x1="42" y1="93" x2="42" y2="112" stroke="#0a44a0" strokeWidth="7" strokeLinecap="round" />
                  <line x1="238" y1="93" x2="238" y2="112" stroke="#0a44a0" strokeWidth="7" strokeLinecap="round" />
                </svg>
                <span className={styles.bLabel}>BRIDGE</span>
              </div>
              <div className={styles.frBridgeTxt}>
                <h3>놀이에서 학습으로</h3>
                <p>
                  더 가르치는 경쟁이 아닌,
                  <br />
                  놀이에서 학습으로 전환하는 잉글리시팝을 통해
                  <br />
                  우리 아이들을 영어로 연결시켜 줍니다.
                </p>
              </div>
            </div>

            {/* 3열 가치 포인트 */}
            <div className={styles.frValues}>
              <div className={styles.frValue}>
                <div className={styles.frValueIco} aria-hidden="true">
                  <svg viewBox="0 0 64 64" fill="none" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <circle cx="32" cy="34" r="24" stroke="#0a44a0" strokeWidth="3" />
                    <circle cx="32" cy="34" r="13.5" stroke="#0a44a0" strokeWidth="3" />
                    <circle cx="32" cy="34" r="5" fill="#ff6400" />
                    <path d="M35 31 L52 14" stroke="#ff6400" strokeWidth="3" />
                    <polyline points="44 13 52 14 51 22" stroke="#ff6400" strokeWidth="3" />
                  </svg>
                </div>
                <h4>
                  전환기 공백 <span className={styles.hl}>해결</span>
                </h4>
                <p>
                  6~9세 핵심 공백기의
                  <br />
                  효과적인 해소
                </p>
              </div>
              <div className={styles.frValue}>
                <div className={styles.frValueIco} aria-hidden="true">
                  <svg viewBox="0 0 64 64" fill="none" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <line x1="9" y1="56" x2="55" y2="56" stroke="#0a44a0" strokeWidth="3" />
                    <rect x="13" y="38" width="9" height="13" rx="2.5" stroke="#0a44a0" strokeWidth="3" />
                    <rect x="27.5" y="31" width="9" height="20" rx="2.5" stroke="#0a44a0" strokeWidth="3" />
                    <rect x="42" y="23" width="9" height="28" rx="2.5" stroke="#0a44a0" strokeWidth="3" />
                    <path d="M12 25 L26 15 L36 19 L51 8" stroke="#ff6400" strokeWidth="3" />
                    <polyline points="43 7 51 8 50 16" stroke="#ff6400" strokeWidth="3" />
                  </svg>
                </div>
                <h4>
                  초등 안착 <span className={styles.hl}>지원</span>
                </h4>
                <p>
                  자신감 있는 시작,
                  <br />
                  성공적인 적용 시스템 구축
                </p>
              </div>
              <div className={styles.frValue}>
                <div className={styles.frValueIco} aria-hidden="true">
                  <svg viewBox="0 0 64 64" fill="none" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <circle cx="25" cy="24" r="8.5" stroke="#0a44a0" strokeWidth="3" />
                    <path
                      d="M10 55 c1.8-9.5 7.6-14.5 15-14.5 s13.2 5 15 14.5"
                      stroke="#0a44a0"
                      strokeWidth="3"
                    />
                    <circle cx="45.5" cy="27" r="6.5" stroke="#0a44a0" strokeWidth="3" />
                    <path d="M42 44 c7 .6 11.8 5 13.2 11" stroke="#0a44a0" strokeWidth="3" />
                    <path
                      d="M53.6 8.2 c-1.5-1.7-4.1-1.5-5.3.4 -1.2-1.9-3.8-2.1-5.3-.4 -1.6 1.8-.8 4.3 1.1 5.9 l4.2 3.4 4.2-3.4 c1.9-1.6 2.7-4.1 1.1-5.9z"
                      fill="#ff6400"
                    />
                  </svg>
                </div>
                <h4>
                  부모의 안심 <span className={styles.hl}>실현</span>
                </h4>
                <p>
                  불안을 안심으로,
                  <br />
                  신뢰로 이어지는 경험
                </p>
              </div>
            </div>

            {/* 알약 CTA: 반투명 + 원이 알약 왼쪽에 겹침 */}
            <div className={styles.frPillWrap}>
              <div className={styles.frPillCombo}>
                <span className={styles.frPlus} aria-hidden="true">
                  +
                </span>
                <span className={styles.frPill}>
                  <svg viewBox="0 0 24 24" fill="none" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <rect x="4" y="14.5" width="4" height="7" rx="1" fill="#fff" />
                    <rect x="10" y="11.5" width="4" height="10" rx="1" fill="#fff" />
                    <rect x="16" y="8.5" width="4" height="13" rx="1" fill="#fff" />
                    <path d="M4 9.5 L10 5.5 L14 7 L20 2.8" stroke="#ffc62e" strokeWidth="2" />
                    <polyline points="16.6 2.8 20 2.8 20 6.2" stroke="#ffc62e" strokeWidth="2" />
                  </svg>
                  <span>
                    지속적 콘텐츠 개발과 업데이트를 통한
                    <br />
                    잉글리시팝 핵심 경쟁력 강화
                  </span>
                </span>
              </div>
            </div>
          </div>
        </section>

        <div className="wrap">
          <span className={styles.eyebrow}>Franchise Process</span>
          <h1 className={styles.title}>
            가맹 <span className={styles.hl}>프로세스</span>
          </h1>
          <p className={styles.sub}>상담부터 개원까지, 8단계로 안내해드립니다.</p>

          <div className={styles.processTrack}>
            <div className={styles.processStep}>
              <span className={styles.stNum}>STEP 01</span>
              <h4>개설상담</h4>
            </div>
            <span className={styles.processArrow}>▶</span>
            <div className={styles.processStep}>
              <span className={styles.stNum}>STEP 02</span>
              <h4>본부심사</h4>
            </div>
            <span className={styles.processArrow}>▶</span>
            <div className={styles.processStep}>
              <span className={styles.stNum}>STEP 03</span>
              <h4>계약</h4>
            </div>
            <span className={styles.processArrow}>▶</span>
            <div className={styles.processStep}>
              <span className={styles.stNum}>STEP 04</span>
              <h4>초도발송</h4>
            </div>
            <span className={styles.processArrow}>▶</span>
            <div className={styles.processStep}>
              <span className={styles.stNum}>STEP 05</span>
              <h4>사전교육</h4>
            </div>
            <span className={styles.processArrow}>▶</span>
            <div className={styles.processStep}>
              <span className={styles.stNum}>STEP 06</span>
              <h4>개설상담</h4>
            </div>
            <span className={styles.processArrow}>▶</span>
            <div className={styles.processStep}>
              <span className={styles.stNum}>STEP 07</span>
              <h4>간판 및 시공</h4>
            </div>
            <span className={styles.processArrow}>▶</span>
            <div className={styles.processStep}>
              <span className={styles.stNum}>STEP 08</span>
              <h4>개원</h4>
            </div>
          </div>
        </div>

        {/* 가맹문의 신청서 — 예전에는 구글폼으로 외부 이동시켰지만, 지금은 이름/연락처/
             이메일/1·2차 희망지역/문의내용 + 개인정보 수집 동의를 사이트 안에서 바로
             입력받는 InquiryForm으로 대체했다(하단 왼쪽 "이전 화면", 오른쪽 "신청하기"). */}
        <section className={styles.inquiry} id="inquiry">
          <div className="wrap">
            <div className={styles.inquiryCard}>
              <h2>가맹문의 신청서</h2>
              <div className={styles.inquiryRule}></div>
              <p className={styles.inquirySub}>
                아래 정보를 입력해 주시면, 가맹 상담 직원이 확인 후 바로 연락 드립니다.
              </p>
              <InquiryForm />
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}
